module.exports = __webpack_public_path__ + "static/media/img_7.31c32376.png";